import { Exclude, Expose } from 'class-transformer';
import { SubdivisionSheetInterface } from '../interfaces/subdivision-sheet.interface';
import { SubdivisionWarrantyStatusEnum } from '../../subdivision/enums/subdivision-warranty-status.enum';
import { SubdivisionOverrideTypeEnum } from '../../subdivision/enums/subdivision-override-type.enum';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { IsBoolean, IsOptional } from 'class-validator';

@Exclude()
export class SubdivisionSheetDto implements SubdivisionSheetInterface {
  @ApiProperty({
    title: 'Id',
  })
  @Expose()
  id!: string;

  @ApiProperty({
    title: 'Name',
  })
  @Expose()
  name!: string;

  @ApiProperty({
    title: 'Address1',
  })
  @Expose()
  address1!: string;

  @ApiProperty({
    title: 'City',
  })
  @Expose()
  city!: string;

  @ApiProperty({
    title: 'BuilderId',
  })
  @Expose()
  builderId!: string;

  @ApiProperty({
    title: 'BuilderName',
  })
  @Expose()
  builderName!: string;

  @ApiProperty({
    title: 'State',
  })
  @Expose()
  state!: string;

  @ApiProperty({
    title: 'Zip',
  })
  @Expose()
  zip!: string;

  @ApiProperty({
    title: 'WarrantyStatus',
  })
  @Expose()
  warrantyStatus!: SubdivisionWarrantyStatusEnum;

  @ApiProperty({
    title: 'RegionId',
  })
  @Expose()
  regionId!: string;

  @ApiProperty({
    title: 'RegionName',
  })
  @Expose()
  regionName!: string;

  @ApiProperty({
    title: 'SupervisorUserIds',
  })
  @Expose()
  supervisorUserIds!: string;

  @ApiProperty({
    title: 'SupervisorFullNames',
  })
  @Expose()
  supervisorFullNames!: string;

  @ApiProperty({
    title: 'phaseStructureType',
  })
  @Expose()
  phaseStructureType!: string;

  @ApiPropertyOptional({
    type: 'boolean',
    default: true,
    title: 'overrideRegionCostPerBoard?',
    description: 'Override Region Cost Per Board',
  })
  @IsBoolean()
  @IsOptional()
  @Expose()
  overrideRegionCostPerBoard?: boolean;

  @ApiProperty({
    type: 'string',
    format: 'date-time',
    title: 'Created At',
    description: 'The date and time at which the subdivision was created.',
  })
  @Expose()
  createdAt!: Date;

  @ApiProperty({
    type: 'string',
    format: 'date-time',
    title: 'Updated At',
    description: 'The date and time at which the subdivision was last updated.',
  })
  @Expose()
  updatedAt!: Date;

  @ApiPropertyOptional({
    type: 'enum',
    enum: SubdivisionOverrideTypeEnum,
    title: 'Override Type',
    description: 'The override type for subdivision costs',
  })
  @Expose()
  overrideType?: SubdivisionOverrideTypeEnum;

  @ApiPropertyOptional({
    type: 'boolean',
    default: false,
    title: 'Allow Payout Amount Editing',
    description:
      'Allow Supervisor to edit the contractor payout amount for Piecework/Special Jobs repairs',
  })
  @IsBoolean()
  @IsOptional()
  @Expose()
  allowPayoutAmountEditing?: boolean;
}
